<footer>
  <!-- <a>Aviso de Privacidad</a>
  <a>Terminos y Condiciones</a> -->
  <p>Ordenaris © 2024</p>
</footer>